import { styled } from '@mui/material/styles';
import { Typography, Button } from '@mui/material';

export const WelcomeTypography = styled(Typography)({
  color: 'black',
  fontWeight: 'bold'
});

export const SubtitleTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary
}));

export const EditProfileButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  height: '45%',
  textTransform: 'none',
  width: '9rem'
})); 